/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsUnityOptionsDistributionFromJSON, FxIdDomainSettingsUnityOptionsDistributionToJSON, } from './FxIdDomainSettingsUnityOptionsDistribution';
/**
 * Check if a given object implements the FxIdDomainSettingsUnityOptions interface.
 */
export function instanceOfFxIdDomainSettingsUnityOptions(value) {
    if (!('Distribution' in value) || value['Distribution'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsUnityOptionsFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Distribution': FxIdDomainSettingsUnityOptionsDistributionFromJSON(json['Distribution']),
    };
}
export function FxIdDomainSettingsUnityOptionsToJSON(json) {
    return FxIdDomainSettingsUnityOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Distribution': FxIdDomainSettingsUnityOptionsDistributionToJSON(value['Distribution']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptions.js.map